import { getToneFromHSLColor } from './toneProvider';
import { HEXToHSL } from './colorConverter';
import { Tone } from './types';
const BLACK = 'black';
const LAVA = 'lava';
const FLAME = 'flame';
const ORANGE = 'orange';
const ACID = 'acid';
const ALGAE = 'algae';
const JELLYFISH = 'jellyfin';
const BLUE = 'blue';
const INDIGO = 'indigo';
const PURPLE = 'purple';
const MAGENTA = 'magenta';
const PINK = 'pink';
export const colors = {
  [BLACK]: '#000000',
  [LAVA]: '#D71F14',
  [FLAME]: '#DF5114',
  [ORANGE]: '#FF673D',
  [ACID]: '#FCFF60',
  [ALGAE]: '#52ED9E',
  [JELLYFISH]: '#2DD7B9',
  [BLUE]: '#5465FF',
  [INDIGO]: '#7241FF',
  [PURPLE]: '#A238FF',
  [MAGENTA]: '#C01FC3',
  [PINK]: '#F673FF'
};
const toneColorsMapping = {
  [Tone.default]: BLACK,
  [Tone.lava]: LAVA,
  [Tone.flame]: FLAME,
  [Tone.orange]: ORANGE,
  [Tone.acid]: ACID,
  [Tone.algae]: ALGAE,
  [Tone.jellyfish]: JELLYFISH,
  [Tone.blue]: BLUE,
  [Tone.indigo]: INDIGO,
  [Tone.purple]: MAGENTA,
  [Tone.magenta]: MAGENTA,
  [Tone.pink]: PINK
};
export const getColorKeyFromTone = toneKey => toneColorsMapping[toneKey] || BLACK;
export const getColorFromHexaCode = (colorCode = '#FE447D') => {
  const hsl = HEXToHSL(colorCode);
  const colorKey = getColorKeyFromTone(getToneFromHSLColor(hsl));
  const color = colors[colorKey];
  return {
    key: colorKey,
    color
  };
};
//# sourceMappingURL=colorProvider.js.map